import { Group } from "@mui/icons-material";
import { IconButton, Tooltip, Zoom } from "@mui/material";
import { isNil } from "lodash";
import { useNavigate } from "react-router-dom";

import { NAV_ROUTES } from "components/NavigationBar/routes";

import { useRoleContext } from "../../hooks";

export function CompanyAdminDetailsButton() {
  const navigate = useNavigate();
  const { getAdminRole } = useRoleContext();
  const role = getAdminRole();

  const companyId = role?.company?.id;

  if (isNil(companyId)) {
    return null;
  }

  const URL = NAV_ROUTES.companyAdmin(companyId);

  return (
    <Tooltip
      title="Company Details"
      placement="right"
      TransitionComponent={Zoom}
    >
      <IconButton color="inherit" onClick={() => navigate(URL)}>
        <Group fontSize="large" />
      </IconButton>
    </Tooltip>
  );
}
